import { z } from 'zod';
import { SocialAccountStatus } from '@anytag/graphql';
import { ToggleOption } from '@anytag/shared-types';
import { BaseValidations } from '@anytag/shared-validations';
import {
  PostsPriceSchema,
} from '../shared';
import { InfluencerSharedKeys } from '../shared/types';
import { SocialAccountsSchema, InfluencerManagersSchema, AddressInformationSchema, PaymentInformationSchema, BrandContentPermissionsSchema } from './sections';

export const InfluencerFormSchema = z
  .object({
    [InfluencerSharedKeys.regionId]: z.string(),
    [InfluencerSharedKeys.introduce]: z.string(),
    [InfluencerSharedKeys.provinceId]: z.string(),
    [InfluencerSharedKeys.dateOfBirth]: z.string(),
    [InfluencerSharedKeys.isProAccount]: z.boolean(),
    [InfluencerSharedKeys.partnerIds]: z.array(z.string()),
    [InfluencerSharedKeys.name]: BaseValidations.NameSchema,
    [InfluencerSharedKeys.notificationSetting]: z.boolean(),
    [InfluencerSharedKeys.gender]: BaseValidations.GenderSchema,
    [InfluencerSharedKeys.talentAgencyIds]: z.array(z.string()),
    [InfluencerSharedKeys.brandAccount]: z.nativeEnum(ToggleOption),
    [InfluencerSharedKeys.status]: z.nativeEnum(SocialAccountStatus),
    [InfluencerSharedKeys.email]: BaseValidations.EmailSchemaOptional,
    [InfluencerSharedKeys.countryId]: BaseValidations.CountryIdSchema,
    [InfluencerSharedKeys.campaignDisplay]: z.nativeEnum(ToggleOption),
    [InfluencerSharedKeys.defaultEngagementSelectionReason]: z.string(),
    [InfluencerSharedKeys.talentAgencyOrPartnerIds]: z.array(z.string()),
    [InfluencerSharedKeys.phoneNumber]: BaseValidations.PhoneNumberOptionalSchema,
    [InfluencerSharedKeys.categoryIds]: BaseValidations.getMaxCategoryIdsSchema(),
    [InfluencerSharedKeys.internalMemo]: z.string(),
  })
  .and(SocialAccountsSchema)
  .and(PostsPriceSchema)
  .and(AddressInformationSchema)
  .and(InfluencerManagersSchema)
  .and(PaymentInformationSchema)
  .and(BrandContentPermissionsSchema);

export type InfluencerFormValues = z.infer<typeof InfluencerFormSchema>;
export type InfluencerFormKeys = keyof InfluencerFormValues;
